import { api } from '.';

export const getDetailOrderConfirmation = async (code: string) => {
  try {
    const response = await api.post(
      'api/order-confirmation-bpr',
      null,
      {
        opportunityId: code,
      },
      {
        baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching order confirmation:', error);
    return error?.response?.status;
  }
};

export const postDetailOrderConfirmation = async (payload: {
  opptNo: string;
  customerResponse: string;
  recaptchaToken: string;
}) => {
  try {
    const response = await api.post(
      `api/submit-order-confirmation-bpr`,
      null,
      { payload: payload },
      {
        baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting order confirmation:', error.response);
    return error?.response?.status;
  }
};

export default {
  getDetailOrderConfirmation,
  postDetailOrderConfirmation,
};
